import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback, FormGroup, Table } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class SubirDocumento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            observacion: "",
            url: "",
            plan_id: null,
            solicitud_id: null,
            proyecto_codigo: null,
        };
    }



    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            observacion: "",
            url: "",
            plan_id: null,
            solicitud_id: null,
            proyecto_codigo: null,
        })
    }

    setSelects(data) {
        this.setState({
            observacion: data.observacion,
            url: (data.url != undefined ? api.BASE_URL + data.url : ""),
            plan_id: data.pk,
            solicitud_id: data.solicitud_id,
            proyecto_codigo: data.solicitud_codigo,
        });
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                getUrl={api.proyectos.plandetrabajo.subirdocumento}
                postUrl={api.proyectos.plandetrabajo.subirdocumento}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Documento ha sido subido con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Subir Documento"}
                buttonTitle={"Subir Documento"}
                buttonIcon={"fa fa-upload fa-lg"}
                notAllowedMessage={"El Plan de Trabajo no puede ser editado en esta etapa porque ya fue avanzada."}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Código</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Proyecto</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Input type="hidden" value={(this.state.plan_id ? this.state.plan_id : "")} onChange={(e) => { return; }} />
                    {this.state.url != "" &&
                        <Col className="col-12">
                            <a target={"_blank"} href={this.state.url}>DESCARGAR DOCUMENTO</a>
                        </Col>
                    }
                    <Col className="col-12">
                        <Label>Archivo{this.state.url && <i className="pl-4">El documento subido puede ser reemplazado.</i>}</Label>
                        <Input type="file" name="file"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observacion" value={this.state.observacion} onChange={(e) => this.setState({ observacion: e.target.value })} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default SubirDocumento;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/SubirDocumento.js